<template><div><h1 id="letzter-spendeneingang" tabindex="-1"><a class="header-anchor" href="#letzter-spendeneingang"><span>Letzter Spendeneingang</span></a></h1>
<p>Letzter Spendeneingang — Zeigt letzten Spendeneingang und letzte Aktion von Adressen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Datei der letzten Spendeneingänge im gewählten Zeitraum [Datum von - Datum bis] für alle Adressen mit dem gewählten Personenmerkmal. Es wird auch die letzte Aktion des Mitarbeiters für diese Adresse gezeigt.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Letzter Spendeneingang</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personenmerkmale</dt>
<dd>mit Kommas trennen, mit ! ausschliessen, * alle</dd>
<dt>Datum von</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Datum bis</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Zuständige ID</dt>
<dd>zuständiger Mitarbeiter, * = alle</dd>
<dt>Ausgabe</dt>
<dd>Standard</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adrnum</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name</td>
<td>Adressname</td>
</tr>
<tr>
<td>Ort</td>
<td>Adressort</td>
</tr>
<tr>
<td>Ereignis</td>
<td>Ereignisnummer und -position</td>
</tr>
<tr>
<td>Datum</td>
<td>Datum des letzten Spendeneingangs</td>
</tr>
<tr>
<td>Betrag</td>
<td>Betrag des letzten Spendeneingangs</td>
</tr>
<tr>
<td>Projekt</td>
<td>Projektnummer des letzten Spendeneingangs</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Bezeichnung des Projektes</td>
</tr>
<tr>
<td>letz. Akt.</td>
<td>letzte Aktion für Adresse</td>
</tr>
<tr>
<td>Code</td>
<td>Aktionscode der letzten Aktion</td>
</tr>
<tr>
<td>ID</td>
<td>Mitarbeiter-Code</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          19.02.2004 09:49:44 svw  Seite     0</span>
<span class="line"></span>
<span class="line">                            letzter Spendeneingang</span>
<span class="line">                Personenmerkmale: \*</span>
<span class="line">                Datum von.....: 01.01.2003 bis: 31.01.2003</span>
<span class="line">                Zuständige ID.: \*</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">  Adrnum Name              Ort       Ereignis  +  Datum     Betrag Projekt Bezeichnung      </span>
<span class="line">-------- ----------------- --------- ------------------ ---------- ------- ---------------  </span>
<span class="line">     651 Kuhn-Wirz Lorenz  Herisau   5397 01 24.01.2003     100.00 1       allgemein       |</span>
<span class="line">    1655 SZ Sammel Zürich  Zürich    3168 01 31.01.2003      50.00 5       Trinkwasser     |</span>
<span class="line">    2350 Luginbühl-Ryf H.  Arlesheim 6123 02 07.01.2003      50.00 1       allgemein       |</span>
<span class="line">    4007 Keller Rosa       Burgistei 4021 00 24.01.2003      11.10 1       allgemein       |</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Für Rosa Keller ist im System die obige Aktion als letzte verbucht worden: Sie hat auf das Ereignis 4021.00 am 24.01.2003 11.10 CHF gespendet. Die Spende wird auf das Projekt 1 (allgemein) verbucht.</p>
</div></template>


